import gql from "graphql-tag";

export const findSistemaPerfiles = gql`
  query findSistemaPerfiles {
    findSistemaPerfiles {
      sadm_sispe_id
      sadm_sispe_nombre
      sadm_gus_id
      sadm_gus_nombre
      accesos {
        sadm_speac_id
        sadm_usu_id
        sadm_sop_id
        sadm_speac_permite
      }
    }
  }
`;
